// // import React, { useEffect, useState } from "react";
// // import {
// //   Dialog,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// // } from "@material-ui/core";
// // import { ItemContext } from "../../Context/ItemContext";
// // import { useLocation, useHistory } from "react-router-dom";
// // import { Fab, Action } from "react-tiny-fab";
// // import "react-tiny-fab/dist/styles.css";
// // import AddIcon from "@material-ui/icons/Add";
// // import CreateIcon from "@material-ui/icons/Create";
// // import PersonAddIcon from "@material-ui/icons/PersonAdd";
// // import AddClient from "../Invoice/AddClient";
// // import AddSupplier from "../Suppliers/AddSupplier";
// // import MeetingForm from "../Meetings/MeetingForm";
// // import Meetings from "../Meetings/Meetings";
// // import { AppContext } from "../../Context/AppContext";
// // import { EditContext } from "../../Context/EditContext";
// // import { useContext } from "react";
// // import AddItem from "../Items/addItem";
// // import MenuIcon from "@material-ui/icons/Menu";
// // // import {AddShoppingCart,Adjust,AcUnit,Report} from '@material-ui/icons';

// // import {
// //   Check,
// //   Pie,
// //   Bag,
// //   Card,
// //   Clock,
// //   Frown,
// //   Order,
// //   Rupee,
// //   Report,
// //   SalesPerson,
// //   Item,
// //   Customer,
// // } from "../Dashboard/Icons";
// // const FabButton = () => {
// //   const location = useLocation();
// //   const mainButtonStyles = {
// //     backgroundColor: "#ef7f1a",
// //   };
// //   const [open, setOpen] = useState(false);
// //   const [openSupplier, setOpenSupplier] = useState(false);
// //   const [openItem, setOpenItem] = useState(false);
// //   const {
// //     showForm,
// //     setShowForm,
// //     stockAdjustmentShowForm,
// //     setStockAdjustmentShowForm,
// //   } = useContext(AppContext);
// //   const { itemId, setItemId } = useContext(ItemContext);
// //   useEffect(() => {
// //     setStockAdjustmentShowForm(false);
// //     setOpen(false);
// //     setOpenItem(false);
// //   }, [location]);
// //   const user = JSON.parse(localStorage.getItem("profile"));
// //   const history = useHistory();
// //   // if(location.pathname === '/invoice') return null
// //   const handleAddMeeting = () => {
// //     //("handleAddMeeting CAlled");
// //     setStockAdjustmentShowForm(true);
// //   };
// //   const handleCloseForm = () => {
// //     setShowForm(false);
// //   };
// //   return (
// //     <div>
// //       <Dialog open={showForm} onClose={handleCloseForm}>
// //         <DialogContent>
// //           <MeetingForm onClose={handleCloseForm} />
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleCloseForm}>Cancel</Button>
// //         </DialogActions>
// //       </Dialog>

// //       <AddClient setOpen={setOpen} open={open} />
// //       <AddSupplier setOpen={setOpenSupplier} open={openSupplier} />
// //       <AddItem setOpen={setOpenItem} open={openItem} />
// //       {!stockAdjustmentShowForm && !open && !openItem && !openSupplier && (
// //         <Fab
// //           mainButtonStyles={mainButtonStyles}
// //           icon={<MenuIcon style={{ transform: "rotate(0deg)" }} />}
// //           alwaysShowTitle={true}
// //           style={{ position: "fixed", bottom: "48px", left: "24px" }}
// //           event="click"
// //         >
// //           <Action
// //             text="Items"
// //             onClick={() => history.push(`/ItemsList`)}
// //             // onClick={handleAddMeeting}
// //             style={{ backgroundColor: "#ef7f1a" }}
// //           >
// //             <svg
// //               xmlns="http://www.w3.org/2000/svg"
// //               viewBox="0 0 48 48"
// //               width="22px"
// //               height="22px"
// //               stroke="black"
// //             >
// //               <path d="M 1 3 L 1 15 L 3 15 L 3 48 L 47 48 L 47 15 L 49 15 L 49 3 Z M 3 5 L 47 5 L 47 13 L 3 13 Z M 5 15 L 45 15 L 45 46 L 5 46 Z M 17.5 19 C 15.578125 19 14 20.578125 14 22.5 C 14 24.421875 15.578125 26 17.5 26 L 32.5 26 C 34.421875 26 36 24.421875 36 22.5 C 36 20.578125 34.421875 19 32.5 19 Z M 17.5 21 L 32.5 21 C 33.339844 21 34 21.660156 34 22.5 C 34 23.339844 33.339844 24 32.5 24 L 17.5 24 C 16.660156 24 16 23.339844 16 22.5 C 16 21.660156 16.660156 21 17.5 21 Z" />
// //             </svg>
// //           </Action>
// //           <Action
// //             text="Stock Summary"
// //             onClick={() => (window.location.href = "/stockDetails")}
// //             style={{ backgroundColor: "#ef7f1a" }}
// //           >
// //             <Report />
// //           </Action>
// //           <Action
// //             text="Payments/Receipts"
// //             onClick={() => (window.location.href = "/meetings")}
// //             style={{ backgroundColor: "#ef7f1a" }}
// //           >
// //             <Report />
// //           </Action>
// //           {/* {user?.result?.userType === "admin" && (
// //               <Action
// //                 text="Stock Adjustments"

// //                 //  onClick={handleAddMeeting}
// //                 onClick={() =>  history.push(`/stockAdjustments`)}
// //                 style={{ backgroundColor: "#ef7f1a" }}
// //               >
// //                 <Item />
// //               </Action>
// //             )} */}

// //           <Action
// //             text="Invoices"
// //             onClick={() => (window.location.href = "/invoices")}
// //             style={{ backgroundColor: "#ef7f1a" }}
// //           >
// //             <Report />
// //           </Action>
// //           {location.pathname !== "/invoice" && (
// //             <Action
// //               text="Adjust Stock"
// //               // onClick={() =>  history.push(`/invoice`)}
// //               onClick={() => (window.location.href = "/stockAdjustment")}
// //               style={{ backgroundColor: "#ef7f1a" }}
// //             >
// //               <Order />
// //             </Action>
// //           )}

// //           {location.pathname !== "/invoice" && (
// //             <Action
// //               text="Add Purchase"
// //               // onClick={() =>  history.push(`/invoice`)}
// //               onClick={() => (window.location.href = "/purchase")}
// //               style={{ backgroundColor: "#ef7f1a" }}
// //             >
// //               <Order />
// //             </Action>
// //           )}
// //         </Fab>
// //       )}
// //     </div>
// //   );
// // };

// // export default FabButton;

// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogContent,
//   DialogActions,
//   Button,
// } from "@material-ui/core";
// import { ItemContext } from "../../Context/ItemContext";
// import { useLocation, useHistory } from "react-router-dom";
// import { Fab, Action } from "react-tiny-fab";
// import "react-tiny-fab/dist/styles.css";
// import AddIcon from "@material-ui/icons/Add";
// import CreateIcon from "@material-ui/icons/Create";
// import PersonAddIcon from "@material-ui/icons/PersonAdd";
// import AddClient from "../Invoice/AddClient";
// import AddSupplier from "../Suppliers/AddSupplier";
// import MeetingForm from "../Meetings/MeetingForm";
// import Meetings from "../Meetings/Meetings";
// import { AppContext } from "../../Context/AppContext";
// import AddItem from "../Items/addItem";
// import MenuIcon from "@material-ui/icons/Menu";
// import { Report, Order } from "../Dashboard/Icons";
// import usePermissions from '../../utils/permissions'; // Import the permissions hook
// import { useContext } from "react";

// const FabButton = () => {
//   const location = useLocation();
//   const mainButtonStyles = {
//     backgroundColor: "#ef7f1a",
//   };
//   const [open, setOpen] = useState(false);
//   const [openSupplier, setOpenSupplier] = useState(false);
//   const [openItem, setOpenItem] = useState(false);

//   const {
//     showForm,
//     setShowForm,
//     stockAdjustmentShowForm,
//     setStockAdjustmentShowForm,
//   } = useContext(AppContext);
//   const { itemId, setItemId } = useContext(ItemContext);

//   useEffect(() => {
//     setStockAdjustmentShowForm(false);
//     setOpen(false);
//     setOpenItem(false);
//   }, [location]);
//   const user = JSON.parse(localStorage.getItem("profile"));

//   const history = useHistory();

//   // Use permissions hook
//   const { isAdmin, canReadPage } = usePermissions();

//   const handleAddMeeting = () => {
//     setStockAdjustmentShowForm(true);
//   };

//   const handleCloseForm = () => {
//     setShowForm(false);
//   };

//   return (
//     <div>
//       <Dialog open={showForm} onClose={handleCloseForm}>
//         <DialogContent>
//           <MeetingForm onClose={handleCloseForm} />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseForm}>Cancel</Button>
//         </DialogActions>
//       </Dialog>

//       <AddClient setOpen={setOpen} open={open} />
//       <AddSupplier setOpen={setOpenSupplier} open={openSupplier} />
//       <AddItem setOpen={setOpenItem} open={openItem} />

//       {!stockAdjustmentShowForm && !open && !openItem && !openSupplier && (
//         <Fab
//           mainButtonStyles={mainButtonStyles}
//           icon={<MenuIcon style={{ transform: "rotate(0deg)" }} />}
//           alwaysShowTitle={true}
//           style={{ position: "fixed", bottom: "48px", left: "24px" }}
//           event="click"
//         >
//           {(isAdmin() || canReadPage("/ItemsList")) && (
//             <Action
//               text="Items"
//               onClick={() => (window.location.href = "/ItemsList")}
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 viewBox="0 0 48 48"
//                 width="22px"
//                 height="22px"
//                 stroke="black"
//               >
//                 <path d="M 1 3 L 1 15 L 3 15 L 3 48 L 47 48 L 47 15 L 49 15 L 49 3 Z M 3 5 L 47 5 L 47 13 L 3 13 Z M 5 15 L 45 15 L 45 46 L 5 46 Z M 17.5 19 C 15.578125 19 14 20.578125 14 22.5 C 14 24.421875 15.578125 26 17.5 26 L 32.5 26 C 34.421875 26 36 24.421875 36 22.5 C 36 20.578125 34.421875 19 32.5 19 Z M 17.5 21 L 32.5 21 C 33.339844 21 34 21.660156 34 22.5 C 34 23.339844 33.339844 24 32.5 24 L 17.5 24 C 16.660156 24 16 23.339844 16 22.5 C 16 21.660156 16.660156 21 17.5 21 Z" />
//               </svg>
//             </Action>
//           )}

//           {(isAdmin() || canReadPage("/units")) && (
//             <Action
//               text="Stock Summary"
//               onClick={() => history.push("/stockDetails")}
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               <Report />
//             </Action>
//           )}

//           <Action
//             text="Payments/Receipts"
//             onClick={() => history.push("/meetings")}
//             style={{ backgroundColor: "#ef7f1a" }}
//           >
//             <Report />
//           </Action>

//                  {/* {isAdmin() && (
//             <Action
//               text="Add User"
//               onClick={() => history.push("/adminDashboard")}
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               <PersonAddIcon />
//             </Action>
//           )} */}

//           {(isAdmin() || canReadPage("Invoice")) && (
//             <Action
//               text="Invoices"
//               onClick={() => history.push("/invoices")}
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               <Report />
//             </Action>
//           )}

//           {location.pathname !== "/invoice" && (
//             <Action
//               text="Adjust Stock"
//                onClick={() => (window.location.href = "/stockAdjustment")}
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               <Order />
//             </Action>
//           )}

//           {location.pathname !== "/invoice" && (isAdmin() || canReadPage("Invoice")) && (
//             <Action
//               text="Add Purchase"
//                 onClick={() => (window.location.href = "/purchase")}
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               <Order />
//             </Action>
//           )}

//           {/* {isAdmin() && (
//             <Action
//               text="Add User"
//               onClick={() => history.push("/adminDashboard")}
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               <PersonAddIcon />
//             </Action>
//           )} */}
//         </Fab>
//       )}
//     </div>
//   );
// };

// export default FabButton;

import React, { useEffect, useState, useContext } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { ItemContext } from "../../Context/ItemContext";
import { useLocation } from "react-router-dom";
import { Fab, Action } from "react-tiny-fab";
import "react-tiny-fab/dist/styles.css";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import AddClient from "../Invoice/AddClient";
import AddSupplier from "../Suppliers/AddSupplier";
import MeetingForm from "../Meetings/MeetingForm";
import Meetings from "../Meetings/Meetings";
import { AppContext } from "../../Context/AppContext";
import AddItem from "../Items/addItem";
import MenuIcon from "@material-ui/icons/Menu";
import { Report, Order, QrScanner, BogieMaster } from "../Dashboard/Icons";
import usePermissions from "../../utils/permissions";

const FabButton = () => {
  const location = useLocation();
  const mainButtonStyles = {
    backgroundColor: "#ef7f1a",
  };
  const [open, setOpen] = useState(false);
  const [openSupplier, setOpenSupplier] = useState(false);
  const [openItem, setOpenItem] = useState(false);

  const {
    showForm,
    setShowForm,
    stockAdjustmentShowForm,
    setStockAdjustmentShowForm,
  } = useContext(AppContext);
  const { itemId, setItemId } = useContext(ItemContext);

  // Reset UI state on page load
  useEffect(() => {
    // Reset states to ensure navbar/panel hides on reload
    setStockAdjustmentShowForm(false);
    setShowForm(false); // Reset form visibility (might control navbar/panel)
    setOpen(false);
    setOpenItem(false);
    setOpenSupplier(false);

    // Optionally, check for a query param to confirm fresh load
    const params = new URLSearchParams(location.search);
    if (params.get("refresh")) {
      // Remove the refresh param to avoid infinite loops
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [location, setShowForm, setStockAdjustmentShowForm]);

  const user = JSON.parse(localStorage.getItem("profile"));
  const { isAdmin, canReadPage, canCreatePage, permissionsLoading } =
    usePermissions();

  const handleAddMeeting = () => {
    setStockAdjustmentShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  // Helper function to navigate with a refresh trigger
  const navigateWithRefresh = (path) => {
    window.location.href = `${path}?refresh=true`; // Add a query param to detect reload
  };

  return (
    <div>
      <Dialog open={showForm} onClose={handleCloseForm}>
        <DialogContent>
          <MeetingForm onClose={handleCloseForm} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseForm}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <AddClient setOpen={setOpen} open={open} />
      <AddSupplier setOpen={setOpenSupplier} open={openSupplier} />
      <AddItem setOpen={setOpenItem} open={openItem} />

      {!stockAdjustmentShowForm && !open && !openItem && !openSupplier && (
        <Fab
            mainButtonStyles={mainButtonStyles}
            icon={<MenuIcon style={{ transform: "rotate(0deg)" }} />}
            alwaysShowTitle={true}
            style={{ position: "fixed", bottom: "48px", left: "24px" }}
            event="click"
        >
          {(isAdmin() || canReadPage("Items")) && (
            <Action
              text="Items"
              onClick={() => navigateWithRefresh("/ItemsList")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="22px"
                height="22px"
                stroke="black"
              >
                <path d="M 1 3 L 1 15 L 3 15 L 3 48 L 47 48 L 47 15 L 49 15 L 49 3 Z M 3 5 L 47 5 L 47 13 L 3 13 Z M 5 15 L 45 15 L 45 46 L 5 46 Z M 17.5 19 C 15.578125 19 14 20.578125 14 22.5 C 14 24.421875 15.578125 26 17.5 26 L 32.5 26 C 34.421875 26 36 24.421875 36 22.5 C 36 20.578125 34.421875 19 32.5 19 Z M 17.5 21 L 32.5 21 C 33.339844 21 34 21.660156 34 22.5 C 34 23.339844 33.339844 24 32.5 24 L 17.5 24 C 16.660156 24 16 23.339844 16 22.5 C 16 21.660156 16.660156 21 17.5 21 Z" />
              </svg>
            </Action>
          )}

          {/* {(isAdmin() || canReadPage("Units")) && (
            <Action
              text="Stock Summary"
              onClick={() => navigateWithRefresh("/stockDetails")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <Report />
            </Action>
          )} */}

          {/* {(isAdmin() || canReadPage("Payment & Recipts")) && (
            <Action
              text="Payments/Receipts"
              onClick={() => navigateWithRefresh("/meetings")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <Report />
            </Action>
          )} */}

          
(isAdmin() ) && (
            <Action
              text="Add User"
              onClick={() => navigateWithRefresh("/adminDashboard")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <PersonAddIcon />
            </Action>
          )

          {(isAdmin() || canReadPage("Invoice")) && (
            <Action
              text="Invoices"
              onClick={() => navigateWithRefresh("/invoices")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <Report />
            </Action>
          )}

          <Action
              text="QR Scanner"
              onClick={() => navigateWithRefresh("/qr-scanner")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <QrScanner/>
            </Action>

             <Action
              text="Bogie Master"
              onClick={() => navigateWithRefresh("/bogie-master")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <BogieMaster/>
            </Action>

{/* <Action
              text="Supplier-Dues"
              onClick={() => navigateWithRefresh("/supplier-dues")} // Updated with refresh
              style={{ backgroundColor: "#ef7f1a" }}
            >
              <Report />
            </Action> */}
{/* 
          {location.pathname !== "/invoice" &&
            (isAdmin() || canReadPage("stockAdjustment")) && (
              <Action
                text="Adjust Stock"
                onClick={() => navigateWithRefresh("/stockAdjustment")} // Updated with refresh
                disabled={
                  permissionsLoading ||
                  (!isAdmin() && !canCreatePage("stockAdjustment"))
                }
                style={{
                  cursor:
                    permissionsLoading ||
                    (!isAdmin() && !canCreatePage("stockAdjustment"))
                      ? "not-allowed"
                      : "pointer",
                  backgroundColor: "#ef7f1a",
                }}
              >
                <Order />
              </Action>
            )} */}

          {/* {location.pathname !== "/invoice" &&
            (isAdmin() || canReadPage("Purchase")) && (
              <Action
                text="Add Purchase"
                onClick={() => navigateWithRefresh("/purchase")} // Updated with refresh
                disabled={
                  permissionsLoading ||
                  (!isAdmin() && !canCreatePage("Purchase"))
                }
                style={{
                  cursor:
                    permissionsLoading ||
                    (!isAdmin() && !canCreatePage("Purchase"))
                      ? "not-allowed"
                      : "pointer",
                  backgroundColor: "#ef7f1a",
                }}
              >
                <Order />
              </Action>
            )} */}
        </Fab>
      )}
    </div>
  );
};

export default FabButton;
